<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Opinion Qualified</h2>
    <div class="button-group">
      <button mat-raised-button color="primary" (click)="onAuditOpinionQualifiedOptionCorrected()" *ngIf="rightItem && matchedItems && matchedItems.length > 0">
        <mat-icon>assignment_turned_in</mat-icon>
        Correct
      </button>
      <button mat-raised-button color="primary" (click)="onCreateAuditOpinionQualifiedOption()">
        <mat-icon>add</mat-icon>
        Add Opinion Qualified
      </button>
    </div>
  </div>
  <app-lookup-table
      [items]="auditOpinionQualifiedOptions()"
      [enableMatching]="true"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditAuditOpinionQualifiedOption($event)"
      (deleteClick)="onDeleteAuditOpinionQualifiedOption($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)"
      (readyToMatch)="onReadyToMatch($event)">
    </app-lookup-table>
</div>
